import React from 'react'
import {
  makeStyles
} from '@material-ui/core'
import ViewTabs from '../../../../organisms/AdvisorView/components/AdvisorViewTabs'
import ConfigurableView from '../../ConfigurableView'
import ClientTagsTab from './ClientTagsTab'
import ProductTagsTab from './ProductTagsTab'

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '1rem',
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '1.75rem'
    }
  }
}))

const tabOptions = {
  client: {
    label: 'Client-Related Tags',
    value: 'client'
  },
  product: {
    label: 'Product-Related Tags',
    value: 'product'
  }
}
const useTabOptions = () => {
  const result = {}
  result.client = tabOptions.client
  result.product = tabOptions.product
  return result
}
function Tags () {
  const classes = useStyles()
  const displayTabOptions = useTabOptions()

  return (
    <ConfigurableView viewPath='@admin-tags'>
      <div className={classes.container}>
        <ViewTabs.Group tabOptions={displayTabOptions}>
          <ViewTabs.Links
            tabsKey='tags_list'
          />
          <ViewTabs.Tab value='client'>
            <ClientTagsTab />
          </ViewTabs.Tab>
          <ViewTabs.Tab value='product'>
            <ProductTagsTab />
          </ViewTabs.Tab>
        </ViewTabs.Group>
      </div>
    </ConfigurableView>
  )
}

export default Tags
